var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Stack, IconButton, Typography, List, ListItemText, ListItem, ListItemIcon, } from '@mui/material';
import NumberIcon from '@mui/icons-material/NumbersRounded';
import Markdown from 'markdown-to-jsx';
export var DisplayMarkdown = function (_a) {
    var children = _a.children, _b = _a.color, color = _b === void 0 ? null : _b;
    return (_jsx(Markdown, { children: children, options: {
            overrides: {
                p: {
                    component: Typography,
                    props: {
                        variant: 'body1',
                        sx: { paddingBottom: 1 },
                    },
                },
                h1: {
                    component: Typography,
                    props: {
                        variant: 'h4',
                        sx: { paddingBottom: 1 },
                    },
                },
                h2: {
                    component: Typography,
                    props: {
                        variant: 'h5',
                    },
                },
                h3: {
                    component: Typography,
                    props: {
                        variant: 'h6',
                    },
                },
                ul: {
                    component: function (_a) {
                        var children = _a.children, props = __rest(_a, ["children"]);
                        return (_jsx(List, __assign({}, props, { children: children })));
                    },
                },
                li: {
                    component: function (_a) {
                        var children = _a.children, props = __rest(_a, ["children"]);
                        return (_jsxs(ListItem, __assign({ sx: { padding: 0, margin: 0, alignItems: 'start' } }, props, { children: [_jsx(ListItemIcon, __assign({ sx: {
                                        color: color,
                                        padding: 0,
                                        marginLeft: '3px',
                                        marginTop: '3px',
                                        minWidth: '30px',
                                    } }, { children: _jsx(NumberIcon, { fontSize: "small" }) })), _jsx(ListItemText, __assign({ sx: { padding: 0, margin: 0 } }, { children: children }))] })));
                    },
                },
                IconButton: {
                    component: IconButton,
                },
                img: {
                    component: function (_a) {
                        var props = __rest(_a, []);
                        return (_jsx(Stack, { children: _jsx("img", __assign({}, props, { alt: "" })) }));
                    },
                },
                Button: {
                    component: Button,
                },
            },
        } }));
};
//# sourceMappingURL=DisplayMarkdown.js.map